var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAudioOn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3249 4.32403C11.5847 4.44892 11.75 4.7117 11.75 5.00001V19C11.75 19.2883 11.5847 19.5511 11.3249 19.676C11.065 19.8009 10.7566 19.7658 10.5315 19.5857L5.73691 15.75H2C1.58579 15.75 1.25 15.4142 1.25 15V9.00001C1.25 8.58579 1.58579 8.25001 2 8.25001H5.73691L10.5315 4.41436C10.7566 4.23425 11.065 4.19914 11.3249 4.32403ZM10.25 6.56048L6.46852 9.58566C6.33554 9.69205 6.1703 9.75001 6 9.75001H2.75V14.25H6C6.1703 14.25 6.33554 14.308 6.46852 14.4144L10.25 17.4395V6.56048Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0703 3.86938L19.6006 4.39979C21.6159 6.41572 22.748 9.14953 22.748 12C22.748 14.8506 21.6159 17.5844 19.6006 19.6003L19.0703 20.1307L18.0095 19.0702L18.5397 18.5398C20.2738 16.8052 21.248 14.4528 21.248 12C21.248 9.54728 20.2738 7.19493 18.5397 5.46029L18.0095 4.92988L19.0703 3.86938ZM15.5403 7.39938L16.0706 7.9298C17.1485 9.00808 17.7541 10.4704 17.7541 11.995C17.7541 13.5197 17.1485 14.982 16.0706 16.0603L15.5403 16.5907L14.4795 15.5302L15.0097 14.9998C15.8065 14.2028 16.2541 13.122 16.2541 11.995C16.2541 10.8681 15.8065 9.78729 15.0097 8.9903L14.4795 8.45988L15.5403 7.39938Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioOn);
export default __webpack_public_path__ + "static/media/audioOn.9b806ab4e1da953eee5c927cbbaf6870.svg";
export { ForwardRef as ReactComponent };